export default __webpack_public_path__ + "static/dodoex-320b278149f95f39805065965fd1b149.jpeg";